// True se una stringa HTML (tipicamente Quill) contiene testo reale.
// Quill "vuoto" salva comunque markup ('<p><br></p>'): senza questo check
// le sezioni condizionate sull'HTML renderizzerebbero un blocco vuoto.
export const htmlHasText = (html) => {
    if (!html || typeof html !== 'string') return false;
    return html.replace(/<[^>]*>/g, '').trim() !== '';
};
